/**
 * Submission counts from GET /api/overview/clinic/?date=…; semantics match the server
 * (per-clinic flags, see overview views). `results` / `summary` are built from the
 * caller's accessible clinics on the server — do not re-filter on the client.
 */
export function overviewSummaryStats(clinicSummaryData) {
  const s = clinicSummaryData?.summary || {};
  return {
    reportSubmissions: s.report_submissions ?? 0,
    collectionSubmissions: s.collection_submissions ?? 0,
    forecastSubmissions: s.forecast_submissions ?? 0,
  };
}
